import React from "react";
import PropTypes from "prop-types";
import "../styles/item-title.scss";

function ItemTitle(props) {
  const { title } = props;
  return <span className="item-title">{title}</span>;
}

ItemTitle.defaultProps = {
  title: ""
};

ItemTitle.propTypes = {
  title: PropTypes.string
};

export default ItemTitle;
